module.exports = __webpack_public_path__ + "img/CtrlRoom_light_on.830cd749.png";